import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconChartLine, IconPointer } from "@tabler/icons-react";
import PreviewShell from "./PreviewShell";

const PreviewEmptyState = () => (
  <PreviewShell>
    <Stack flex="1" align="center" justify="center">
      <div className="al-text-center al-max-w-sm">
        <Stack justify="center" className="al-mb-4">
          <div className="al-relative">
            <IconChartLine className="al-h-16 al-w-16 al-text-gray-300" strokeWidth={1.5} />
            <IconPointer className="al-h-6 al-w-6 al-text-primary al-absolute -al-right-1 -al-bottom-1" strokeWidth={2} />
          </div>
        </Stack>
        <Typography variant="body" weight="medium" className="al-mb-2 al-text-gray-700">
          Select a metric to preview
        </Typography>
        <Typography variant="body" size="xs" className="al-text-gray-500">
          Choose a metric from the left panel to see a live preview of your subscription
        </Typography>
      </div>
    </Stack>
  </PreviewShell>
);

export default PreviewEmptyState;
